<div class="header"
     data-testid="open-items-header"
     role="toolbar"
     aria-label="Issue management controls">
  <div class="header-container">
    <div class="header-actions"
         data-testid="header-actions"
         role="group"
         aria-label="Header actions">
      <div class="left-actions"
           data-testid="left-actions"
           role="group"
           aria-label="View controls">
        <button class="filter-btn"
                [class.filter-btn--active]="selectedFiltersCount() > 0"
                (click)="onShowFilter.emit()"
                data-testid="filter-btn"
                [attr.aria-label]="selectedFiltersCount() > 0 ? 'Toggle filters (' + selectedFiltersCount() + ' applied)' : 'Toggle filters'">
          <i [class]="selectedFiltersCount() > 0 ? 'pi pi-filter-fill' : 'pi pi-filter'"
             aria-hidden="true"></i>
          @if (selectedFiltersCount() > 0) {
            <span class="filter-count">{{ selectedFiltersCount() }}</span>
          }
        </button>
        <button class="expand-all-btn"
                (click)="onCollapseItemsToggleClick()"
                [title]="areItemsCollapsed() ? 'Expand All' : 'Collapse All'"
                data-testid="expand-all-btn"
                [attr.aria-label]="areItemsCollapsed() ? 'Expand all issues' : 'Collapse all issues'"
                [attr.aria-pressed]="areItemsCollapsed() ? 'false' : 'true'">
          <img src="assets/icons/collapse-all.svg"
               alt=""
               class="expand-icon"
               aria-hidden="true" />
        </button>
        <button class="add-item-btn"
                (click)="onAddItem.emit()"
                data-testid="add-item-btn"
                aria-label="Add new item">
          <i class="pi pi-plus"
             aria-hidden="true"></i>
        </button>
      </div>
      <div class="right-actions"
           data-testid="right-actions"
           role="group"
           aria-label="Selection controls">
        @if (showSelectAll()) {
          <button class="select-all-btn"
                  (click)="onSelectAll.emit()"
                  data-testid="select-all-btn"
                  aria-label="Select all issues on the current page">
            {{areAllSelected() ? 'Clear All' : 'Select All'}}
          </button>
        }
      </div>
    </div>

    <!-- Applied Filters Section -->
    @if (selectedFiltersCount() > 0) {
      <div class="applied-filters-section"
           data-testid="applied-filters-section"
           role="region"
           aria-label="Applied filters">
        <div class="applied-filters-container">
          <ng-content></ng-content>
        </div>
      </div>
    }

    <!-- Divider -->
    <div class="header-divider"></div>
  </div>
</div>